import Vue from 'vue'

// URL生成メソッド群を宣言

export const createUrl = {
  // 検索ページURL／特集ページのページング用URLを生成
  createSearchUrl(query, url = '/s/') {
    // パラメータ値をURLエンコード
    const params = {}
    Object.keys(query).forEach((column) => {
      params[column] = Vue.options.filters.urlencode(query[column])
      // スラッシュのエンコード対応（%2F⇒%25252F）
      params[column] = params[column].replace(/%2F/g, '%25252F')
    })
    // まとめページ用にURLを変更する
    if (params.eventTag) {
      url = '/sm/' + params.eventTag + '/'
    }

    let stationMode = false
    if (params.area && params.line && params.station) {
      url = `/station/ar-${params.area}/li-${params.line}/st-${params.station}/`
      stationMode = true
    }

    // キーワード指定
    if (params.keyword && !stationMode) {
      url += `q-${params.keyword}/`
    }

    // 都道府県指定
    if (params.prefecture && !stationMode) {
      url += `pr-${params.prefecture}/`

      // 市区町村指定
      if (params.city) {
        url += `ci-${params.city}/`
      }
      // エリア指定
    } else if (params.area && !stationMode) {
      url += `ar-${params.area}/`
    }

    // イベント規模指定
    if (params.eventType) {
      url += `sc-${params.eventType}/`
    }

    // 設備サービス指定
    if (params.service) {
      url += `sv-${params.service}/`
    }

    // 施設の種類指定
    if (params.facilityType) {
      url += `ft-${params.facilityType}/`
    }

    // 並び順指定
    if (params.order) {
      url += `so-${params.order}/`
    }

    // ページ指定
    if (params.page) {
      url += `p-${params.page}/`
    }

    return url
  },

  // 検索ページURLのCanonicalを生成
  createSearchCanonical(query) {
    const canonicalQuery = { ...query }
    const eventTypeLength = query.eventType.length
    const serviceLength = query.service.length
    if (eventTypeLength > 1) {
      const eventType = query.eventType.reduce((a, b) => {
        return Math.min(a, b)
      })
      canonicalQuery.eventType = [eventType.toString()]
    }
    if (serviceLength > 1) {
      const service = query.service.reduce((a, b) => {
        return Math.min(a, b)
      })
      canonicalQuery.service = [service.toString()]
    }
    if (eventTypeLength > 1 || serviceLength > 1) {
      return this.createSearchUrl(canonicalQuery)
    } else {
      return ''
    }
  },

  // 施設詳細ページURLを生成
  createFacilityUrl(code) {
    // URLエンコード
    const param = Vue.options.filters.urlencode(code)

    return `/p/${param}/`
  },

  // お知らせ詳細ページURLを生成
  createNewsUrl(id) {
    return `/n/${id}/`
  },

  // まとめページURLを生成
  createSummaryUrl(tag) {
    const encodeTag = Vue.options.filters.urlencode(tag)
    return `/sm/${encodeTag}/`
  },

  // 路線一覧URLを生成
  createLineStationUrl(area, line, name) {
    const encodeArea = Vue.options.filters.urlencode(area)
    const encodeName = Vue.options.filters.urlencode(name)
    if (line !== '') {
      const encodeLine = Vue.options.filters.urlencode(line)
      return `/station/ar-${encodeArea}/li-${encodeLine}/st-${encodeName}/`
    }
    return `/station/ar-${encodeArea}/li-${encodeName}/`
  },
  // エリア別路線一覧URL生成
  createAreaStationUrl(area) {
    const encodeArea = Vue.options.filters.urlencode(area)
    return `/station/ar-${encodeArea}/`
  }
}
